export class triggerdetailforautomation {
  apiendpoint: string;
  endpintusertoken: string;
}
export interface WeebHookDetail {
  webhookurl: string;
}

export interface TriggerDetailForAutomation {
  apiendpoint: string;
  endpintusertoken: string;
}

export interface TriggerDetails {
  weebHookDetail: WeebHookDetail;
  triggerDetailForAutomation: TriggerDetailForAutomation;
}
